<template>
 <div class="w_content">
		<div class="women">
			<a href="#"><h4>AWARDEES SEARCH</h4></a>
			<br>
		<h1 v-if="loadingTag">Searching........</h1>
		     <div class="clearfix"></div>	
		</div>
        
        
		<!-- grids_of_4 -->
		<!--<div class="grids_of_4"> -->

			

		 <div class="grid1_of_4" v-for="profiles in searchResults" v-bind:key="profiles._id">
				<div class="content_box">
			   	   	 <img :src="profiles.awardeeProfileImage" class="img-responsive" style="width: 280px; height: 200px; pointer: finger;" alt="">
				   	  
				    <h3> {{profiles.awardName}} </h3>
					<p>{{profiles.awardeeCountry}} </p>
					 <h4>{{profiles.awardYear}} - {{profiles.honour}}</h4>
				     <p>{{profiles.context}} </p>
					 <div class="grid_1 simpleCart_shelfItem">
				    
					 <div class="item_add"><span class="item_price" style="color: black;"><h6>{{profiles.awardeeBirthYear}} - {{profiles.awardeeDeathYear}}</h6></span></div>
					<div class="item_add"><span class="item_price" @click="viewProfile(profiles.profileId)"><a href="">VIEW</a></span></div>
					 </div>
			   	</div>
				   <div class="clearfix"></div>
				   <p></p>
				   <p></p>
			</div>
			<p></p>
			<p></p>
			<div class="clearfix"></div>
		<!-- </div>-->
		
		
		
        
			<div class="clearfix"></div>
            <p></p>
			<p></p>
  		<div style="text-align: center;">
        <!--    <button @click="prev()" class="btn btn-default"> <i><</i> Prev</button> | <button @click="next()" class="btn btn-default">Next <i>></i></button>-->
        </div>    
            
		</div>
		
</template>

<script>
import axios from "axios";

export default {
  name: 'searchPage',
 props:
 {
     searchString: 
    {
     type: String,
      required: true
  }
 },
data()
{
    return {
        searchValue: "",
		searchResults: [],
		loadingTag: true
    }
},
async mounted()
{
	this.searchResults = [];
    this.searchValue = this.searchString;
    //fire axios graphQl query using props
       try{
                    let token = localStorage.getItem("token");
    
                    let graphResponse = await axios.post("https://time-person-mofe.herokuapp.com/graphql",
                    {
                       query:`
                      {
					ProfileSearch(searchString: "${this.searchValue}")
					{
					    awardYear
						awardName
						honour
						awardeeCountry
						awardCategory
						awardeeProfileImage
						awardeeTitle
						profileId
						status
					}
					}
					   `
					   },
					   {"Authorization": "Bearer "+token});

					//process response
					
				   //alert(JSON.stringify(graphResponse.data.data.ProfileSearch[0].status));
				   if(graphResponse.data.data.ProfileSearch[0].status == "success")
				   {
					   this.loadingTag = false;
					   this.searchResults = graphResponse.data.data.ProfileSearch;
					   
				   }
				   else{
					    this.loadingTag = false;
					   alert("Search returned no values for query sent to cloud storage. Enter a new search query and try again");
				   }

            }
            catch(error)
            {
				 alert(`Error searching profile data ${error}`);
				 this.loadingTag = false;
            }
},
methods:
{
    searchGraphql: async function()
    {
        //fire axios graphQl query using props
        //this.searchString
    },
    
	viewProfile: function(profileId)
	{
		this.$router.push(`/timeawards/profileView/awardee/${profileId}`);
	}
}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
